import ASC from "../constants/AmuletStackerConstants"
import SC from "../constants/StackerConstants"

export const initialState = {
  chain: {
    chainBaseProduct: "",
    chainVariantCode: "",
    thickness: 0,
  },
  maxItems: {
    small: 3,
    large: 7,
  },
  productListExpanded: false,
  productInfo: { title: "", description: { __html: "" }, pid: "", url: "" },
  search: {
    fq: undefined,
    pageNumber: 0,
    pageSize: 40,
    q: "builder/amulet-builder",
    requestType: "search",
    search: "true",
    searchType: "category",
    sort: "low_price asc",
  },
}

export default function amuletStackerReducer(
  previousState = initialState,
  action
) {
  switch (action.type) {
    case ASC.SET_SELECTED_CHAIN:
      return { ...previousState, chain: action.payload }
    case ASC.PRODUCT_LIST_EXPANDED:
      return { ...previousState, productListExpanded: action.payload }
    case SC.SHOW_PRODUCT_INFO:
      return { ...previousState, productInfo: action.payload }
    case SC.PRODUCTS_NEXT_PAGE:
      return {
        ...previousState,
        search: {
          ...previousState.search,
          pageNumber: previousState.search.pageNumber + 1,
        },
      }
    default:
      return previousState
  }
}
